module.exports = __webpack_public_path__ + "img/integration1.1cc28d13.png";